import React, { Component } from 'react';
import { Container, Button } from 'reactstrap';

class Login extends Component {
  // static propTypes = {
  //   error: PropTypes.object,
  //   loginAsync: PropTypes.func.isRequired,
  // };

  // static defaultProps = {
  //   error: undefined,
  // };

  // constructor(props) {
  //   super(props);
  // }

  state = {
    username: '',
    password: '',
  };

  render() {
    return (
      <Container>
        <Button>Login</Button>
      </Container>
    );
  }
}

export { Login };



// WEBPACK FOOTER //
// ./src/business/login.js